import styled from "styled-components";
import { pxToRem } from "styles/utils";
import { ModalCloseButtonBase, ModalOverlayBase, ModalSurfaceBase } from "../ModalPrimitives";

export const ModalContainer = styled(ModalOverlayBase)``;

export const ModalContent = styled(ModalSurfaceBase)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: min(100%, ${pxToRem(429)});
  min-height: ${pxToRem(271)};
  padding: ${({ theme }) => pxToRem(theme.spacing.xxl)};

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${({ theme }) => pxToRem(theme.fontSize.xl)};
    font-weight: 500;
    line-height: 1.35;
    text-align: center;
  }
`;

export const ModalIcon = styled.svg`
  width: ${pxToRem(40)};
  height: ${pxToRem(40)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.lg)};
  flex: 0 0 auto;
  color: ${({ theme }) => theme.colors.success};
`;

export const CloseButton = styled(ModalCloseButtonBase)`
  position: absolute;
  top: ${({ theme }) => pxToRem(theme.spacing.sm)};
  right: ${({ theme }) => pxToRem(theme.spacing.sm)};
`;
